import { ApiHttpService, ApiHttpServiceNewApi } from '../ApiHttpService';
import { ConfigParameters } from '../../models/ConfigParameters';
import { ParametersSerializer } from '../serializers/ParametersSerializer';
import { constants } from '../../config';

const PARAMETERS_PATH = 'parametros';

const NEWAPI_FEATUREFLAGS = '/FeatureFlagES';

class ParametersController {
  static async all() {
    let url = PARAMETERS_PATH;
    if (constants.refreshConfigParams === 'true') {
      url = `${PARAMETERS_PATH}?timestamp=${new Date().getTime()}`;
    }
    const response = await ApiHttpService.get(url);
    const deSerializedParameters = ParametersSerializer.deSerialize(response.data);
    return new ConfigParameters(deSerializedParameters);
  }

  static async findFeatureFlagsNewApi() {
    try {
      const response = await ApiHttpServiceNewApi.get(NEWAPI_FEATUREFLAGS);
      return response.data.data.features;
    } catch (error) {
      return {
        'whatsapp-chat': {
          enabled: false,
        },
      };
    }
  }
}

export { ParametersController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ParametersController.js